<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>文件管理</el-breadcrumb-item>
    <el-breadcrumb-item>文件上传</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card>
<el-button @click="dialogVisible=true">上传文件</el-button>
<el-table
    ref="multipleTable"
    :data="cloudFileList"
    border
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%"
    >
    <el-table-column
      label="上传ID"
      width="120"
      :show-overflow-tooltip="true"
      prop="cloud_id">
      
    </el-table-column>
    <el-table-column
      label="文件介绍"
      width="120"
      :show-overflow-tooltip="true"
      prop="particulars">
      
    </el-table-column>
    <el-table-column
      label="文件大小（M）"
      width="130"
      :formatter="formatter_file_size"
      :show-overflow-tooltip="true"
      prop="file_size">
      
    </el-table-column>
    
    <el-table-column
      prop="sub_time"
      label="上传时间"
      :show-overflow-tooltip="true"
      width="170">
    </el-table-column>
    <el-table-column
      prop="old_name"
      label="文件名"
      :show-overflow-tooltip="true"
      width="170">
    </el-table-column>
    <el-table-column
      prop="is_public"
      label="文件权限"
      :formatter="is_publicFormatter"
      :show-overflow-tooltip="true"
      width="170">
    </el-table-column>
 <el-table-column
      label="操作"
      width="340">

        <template slot-scope="scope" >
   <el-button type="primary"   @click="downFile(scope.row)">下载</el-button>
   <el-button type="danger"   @click="delFile(scope.row)">删除</el-button>
   <el-button type="primary"   @click="updataFileByIsPublic(scope.row)">{{scope.row.is_public==1?'设为私有':'设为公有'}}</el-button>
      </template>
    </el-table-column>

  </el-table>



  </el-card>

  <el-dialog
  title="文件上传"
  :visible.sync="dialogVisible"
  width="50%"
 >
  <!-- 添加工作 -->
  <el-form :model="formData"  ref="ruleForms" label-width="100px" class="demo-ruleForm">

  <el-form-item label="文件介绍">
    <el-input type="textarea" v-model="formData.particulars"></el-input>
  </el-form-item>

  <el-form-item label="是否公共" prop="is_public">
   <el-radio-group v-model="formData.is_public">
      <el-radio border :label="false">私有</el-radio>
      <el-radio border :label="true">公用</el-radio>
    </el-radio-group>
    </el-form-item>

    <el-form-item label="上传附加文件" span='8'>
            <el-upload
                class="upload-demo"
                drag
                action="https://jsonplaceholder.typicode.com/posts/"
                :auto-upload="false"
                :on-change="fileChange3"
                ref="uploadss"
                :limit="5"
                :on-remove="fileRemove3"
                width="40%"
              
                >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
              <div v-if="progressShow">
                <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage" ></el-progress>
              </div>
          </el-form-item>



  <el-form-item>
    
    <el-button type="primary" @click="subfile()">提交</el-button>
    <!-- <el-button @click="resetForm('ruleForms')">重置</el-button> -->
  </el-form-item>
</el-form>
</el-dialog>
</div>
</template>

<script>
export default {
  created(){
    this.getCloudFiles()
  },
data(){
    return{
      progressShow:false,
      percentage:0,
        formData:{
            particulars:'',
            fileList7:[],
          fileList8:[],
          fileList:[],
            is_public:false,
            file:null
        },
        dialogVisible:false,
        cloudFileList:[],
    }
},methods:{
  getCloudFiles(){
    this.axios.post("/cloudFile/getCloudFiles")
             .then(resp=>{
              if(resp.data.status==1){
                console.log(resp.data.result)
                this.cloudFileList=resp.data.result
              }
             })
  },
    subfile(){
      const subData= this.getFormData()
      let config = { headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: function(progressEvent) {
        this.progressShow = true
          let process = (progressEvent.loaded / progressEvent.total * 100 | 0)
          this.percentage =process
            }.bind(this)
          }

  
        this.axios.post("/cloudFile/subFile", subData,config,this.getonUploadProgress)
        .then((resp) => {
          if (resp.data.status == 1) {
                 this.dialogVisible=false
    
            this.$message.success("添加成功");
            this.getCloudFiles()
          } else {
            this.$message.error("发生过错误"+resp.data.message);
            this.loading=false
          }
          this.progressShow = false
        })
        .catch((err) => {
          this.progressShow = false
          this.$message.error("出错");
          this.loading=false
        });

    },fileChange3(file, fileList){
      let isTrue= this.beforeAvatarUploads(file)
      if(isTrue){
        this.fileList7=fileList
       }else{
        fileList.splice(fileList.length-1)
       }
      },fileRemove3(file, fileList){
        this.fileList7=fileList
      },  formatter_file_size(row, column){
       
       return (row.file_size/1024/1024).toFixed(2)
      },    beforeAvatarUploads(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isLt2M) {
          this.$message.error('文件大小不能超过 20MB!');
        }
        return isLt2M;
      },
      getFormData(){
        const fd = new FormData();
        fd.append("particulars",this.formData.particulars)
        fd.append("is_public",this.formData.is_public)
        this.fileList7.forEach((file) => {
          fd.append("fileList", file.raw);
       });
       return fd
      },downFile(data){
        console.log(data)
      const formData = new FormData()
      formData.append('filePath', data.cloud_file_url)
      this.axios({
            url: "/file/downFile",   //后端地址
            method: "post",
            data:formData, //请求参数
            headers: {  
            'Access-Control-Allow-origin': '*', 'Content-Type': 'application/json; charset=UTF-8',
            },
            // contenType:'application/json',
            responseType: "blob"
          })
            .then(res => {
              console.log(res.data)
          const blob = new Blob([res.data], { type: 'xlsx' });
          const fileName = data.old_name; 
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink); 
            this.selectData=false
      
            })
      },is_publicFormatter(row, column){
       if(row.is_public){
        return "公用文件"
       }else{
        return "私有文件"
       }
      },delFile(data){
        const fd = new FormData();
        fd.append("cloud_file_id",data.cloud_file_id)
        fd.append("filePath",data.cloud_file_url)
        this.axios.post("/cloudFile/delCloudFile",fd)
        .then((resp) => {
          if (resp.data.status == 1) {
            this.getCloudFiles()
            this.$message.success("删除成功");
          } else {
            this.$message.error("发生过错误"+resp.data.message);

          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
      },updataFileByIsPublic(data){
        const fd = new FormData();
        if(data.is_public){
          fd.append("is_public",false)
        }else{
          fd.append("is_public",true)
        }
        fd.append("cloud_file_id",data.cloud_file_id)
        this.axios.post("/cloudFile/updataFileByIsPublic",fd)
        .then((resp) => {
          if (resp.data.status == 1) {
            this.getCloudFiles()
            this.$message.success("修改成功");
          } else {
            this.$message.error("发生过错误"+resp.data.message);

          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
      }
}

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/teacher/CloudFile.vue